export const API_URL = "https://mgga-marketing-material.onrender.com";
export const API_URL2 = "http://localhost:3001";
